function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M18.22.047a2 2 0 012 2v2.117c0 .189-.026.372-.075.545H.121a2.001 2.001 0 01-.076-.545V2.047a2 2 0 012-2H18.22z",
  id: "wedding_sm_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.38.052a2.54 2.54 0 012.165 3.868H.575A2.54 2.54 0 012.74.051h11.64z",
  id: "wedding_sm_svg__c"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v26H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.264 17.073)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "wedding_sm_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#wedding_sm_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.277-.656a2.464 2.464 0 110 4.928 2.464 2.464 0 010-4.928zm4.928 0a2.464 2.464 0 110 4.928 2.464 2.464 0 010-4.928zm4.928 0a2.464 2.464 0 110 4.928 2.464 2.464 0 010-4.928zm4.928 0a2.464 2.464 0 110 4.928 2.464 2.464 0 010-4.928zm4.928 0a2.464 2.464 0 110 4.928 2.464 2.464 0 010-4.928z",
  fill: "#1E88E5",
  mask: "url(#wedding_sm_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E88E5",
  mask: "url(#wedding_sm_svg__b)",
  d: "M-.444-.656h20.665v2.464H-.444z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.808 11.868)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "wedding_sm_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#wedding_sm_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.641-.546c1.117 0 2.022.918 2.022 2.051s-.905 2.051-2.022 2.051a2.027 2.027 0 01-1.937-1.461 1.938 1.938 0 01-1.87 1.461c-.926 0-1.7-.66-1.89-1.54a2.024 2.024 0 01-1.957 1.54c-1.117 0-2.022-.918-2.022-2.051S-.13-.546.987-.546c.976 0 1.79.7 1.98 1.633A1.935 1.935 0 014.834-.368c.866 0 1.6.578 1.846 1.375A2.027 2.027 0 018.641-.546zm7.764 0c1.117 0 2.022.918 2.022 2.051s-.905 2.051-2.022 2.051a2.022 2.022 0 01-1.86-1.247 2.017 2.017 0 01-1.86 1.247c-1.116 0-2.022-.918-2.022-2.051s.906-2.051 2.022-2.051c.836 0 1.553.514 1.861 1.247a2.017 2.017 0 011.859-1.247z",
  fill: "#1E88E5",
  mask: "url(#wedding_sm_svg__d)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E88E5",
  mask: "url(#wedding_sm_svg__d)",
  d: "M-.04-.546h16.96v2.051H-.04z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.568 4.097c.896-.812 2.117-1.046 3.102-.52l.054.03c1.284.729 1.66 2.508.869 4.002a3.513 3.513 0 01-.818 1.029L13.46 11.6l-3.19-2.954a3.523 3.523 0 01-.828-1.037c-.802-1.516-.404-3.324.924-4.032.984-.526 2.205-.292 3.1.52l.052.048.051-.048zm2.812 4.09c.273-.234.506-.524.683-.859.657-1.24.34-2.68-.676-3.222l-.051-.026c-.821-.405-1.875-.125-2.593.695l-.226.258-.226-.258c-.732-.838-1.816-1.111-2.644-.669-1.015.542-1.332 1.982-.676 3.222.178.336.412.627.696.87l2.8 2.592 2.913-2.604zm5.326 8.886c.988 0 1.788.8 1.788 1.787v4.767H3.264V18.86c0-.987.8-1.787 1.788-1.787h16.654zm1.463 1.787c0-.807-.655-1.462-1.463-1.462H5.052c-.808 0-1.463.655-1.463 1.462v4.442h19.58V18.86z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.975 11.927c.988 0 1.788.8 1.788 1.788v3.508l-.002.175H4.996l-.001-.162v-3.521c0-.988.8-1.788 1.788-1.788h13.192zm1.463 1.788c0-.808-.655-1.463-1.463-1.463H6.783c-.808 0-1.463.655-1.463 1.463v3.358h16.118v-3.358zM6.239 18.753a2.274 2.274 0 002.269 2.279 2.274 2.274 0 002.269-2.278v-.002h.324v.001a2.274 2.274 0 002.269 2.279 2.274 2.274 0 002.269-2.278v-.002h.324v.001a2.274 2.274 0 002.269 2.279 2.274 2.274 0 002.269-2.278v-.002h.323v.001a2.274 2.274 0 002.27 2.279l.075-.003v.327h-.075a2.594 2.594 0 01-2.431-1.696 2.594 2.594 0 01-2.431 1.697A2.594 2.594 0 0115.8 19.66a2.594 2.594 0 01-2.431 1.697 2.594 2.594 0 01-2.431-1.697 2.594 2.594 0 01-2.431 1.697 2.594 2.594 0 01-2.431-1.697 2.594 2.594 0 01-2.431 1.697l-.057-.003v-.323h.057c1.253 0 2.27-1.02 2.27-2.277l-.002-.002h.325v.001z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.796 13.444c0 .987.797 1.787 1.78 1.787s1.78-.8 1.78-1.786v-.001h.324c0 .987.797 1.787 1.78 1.787s1.78-.8 1.78-1.786v-.001h.324c0 .987.797 1.787 1.78 1.787s1.78-.8 1.78-1.786v-.001h.324a1.784 1.784 0 001.995 1.774v.327a2.104 2.104 0 01-2.158-1.288 2.104 2.104 0 01-1.941 1.3 2.104 2.104 0 01-1.942-1.3 2.104 2.104 0 01-1.942 1.3 2.104 2.104 0 01-1.942-1.3 2.104 2.104 0 01-1.942 1.3 2.104 2.104 0 01-1.942-1.3 2.104 2.104 0 01-2.32 1.265v-.331a1.78 1.78 0 002.158-1.746v-.001h.324z",
  fill: "#371447",
  fillRule: "nonzero"
}));

function SvgWeddingSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default SvgWeddingSm;